import React from 'react';
import SearchEventsRecentlyAttended from '../../searches/SearchEventsRecentlyAttended';
import { H4, DivWithShadowMediumUp } from '@styled';

const MyEventHistory = () => (
    <div>
        <H4 className="mb-1.5rem">My Recent Event History</H4>

        <DivWithShadowMediumUp>
            <SearchEventsRecentlyAttended />
        </DivWithShadowMediumUp>
    </div>
);
export default MyEventHistory;
